<ng-container *ngIf="notification">

  <!-- ============================================================ -->
  <!-- MODE SIMPLE — pas de details : toast minimaliste top-center  -->
  <!-- ============================================================ -->
  <div
    *ngIf="!hasCorrections() && !minimized"
    class="toast-wrap"
    [ngClass]="getTypeClass()">
    <div class="toast-card" [@toastIn] role="alert">
      <span class="toast-dot" aria-hidden="true">
        <span class="toast-dot-inner"></span>
      </span>

      <div class="toast-body">
        <p class="toast-message">{{ notification.message }}</p>
        <p class="toast-description" *ngIf="notification.description">{{ notification.description }}</p>
        <span class="toast-time">{{ notification.timestamp | date:'HH:mm:ss' }}</span>
      </div>

      <button type="button" class="toast-close" (click)="closeNotification()" aria-label="Fermer">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- MODE DETAILLE — avec details : dialog premium centré          -->
  <!-- ============================================================ -->
  <div
    *ngIf="hasCorrections() && !minimized"
    class="dialog-overlay"
    [ngClass]="getTypeClass()"
    [@backdropIn]>
    <section
      class="dialog-card"
      [@dialogIn]
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="global-error-title">

      <div class="dialog-glow" aria-hidden="true"></div>

      <header class="dialog-header">
        <div class="dialog-heading">
          <span class="dialog-icon">
            <span class="dialog-icon-pulse"></span>
            <mat-icon>{{ getIcon() }}</mat-icon>
          </span>

          <div class="dialog-titles">
            <div class="dialog-kicker">
              <span class="dialog-kicker-dot"></span>
              <span class="dialog-kicker-text">{{ getTitle() }}</span>
              <span class="dialog-kicker-sep" aria-hidden="true">·</span>
              <span class="dialog-kicker-count">{{ getCountLabel() }} correction<ng-container *ngIf="detailCount() > 1">s</ng-container></span>
            </div>
            <h2 id="global-error-title">{{ notification.message }}</h2>
            <p class="dialog-subtitle">{{ getSubtitle() }}</p>
          </div>
        </div>

        <div class="dialog-actions">
          <button type="button" class="icon-action" aria-label="Réduire" (click)="minimizeNotification()">
            <mat-icon>remove</mat-icon>
          </button>
          <button type="button" class="icon-action" aria-label="Fermer" (click)="closeNotification()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </header>

      <div class="dialog-body">
        <p class="dialog-description" *ngIf="notification.description">{{ notification.description }}</p>

        <ol class="detail-list" [@listStagger]="detailCount()">
          <li
            *ngFor="let detail of notification.detailItems; let i = index; trackBy: trackDetail"
            class="detail-item">
            <span class="detail-index" aria-hidden="true">{{ i + 1 }}</span>
            <div class="detail-content">
              <span class="detail-field" *ngIf="detail.field">
                <mat-icon class="detail-field-icon">north_east</mat-icon>
                <span class="detail-field-text">{{ formatField(detail.field) }}</span>
              </span>
              <div class="detail-message">{{ detail.message }}</div>
            </div>
          </li>
        </ol>
      </div>

      <footer class="dialog-footer">
        <span class="dialog-meta">
          <mat-icon class="dialog-meta-icon">schedule</mat-icon>
          {{ notification.timestamp | date:'HH:mm:ss' }}
          <ng-container *ngIf="notification.code">
            <span class="dialog-meta-sep" aria-hidden="true">·</span>
            <span class="dialog-meta-code">code {{ notification.code }}</span>
          </ng-container>
        </span>
        <button type="button" class="dialog-cta" (click)="closeNotification()">
          J'ai compris
        </button>
      </footer>
    </section>
  </div>

  <!-- ============================================================ -->
  <!-- ÉPINGLE — état minimisé                                       -->
  <!-- ============================================================ -->
  <button
    *ngIf="minimized"
    type="button"
    class="error-pin"
    [ngClass]="getTypeClass()"
    [@toastIn]
    (click)="restoreNotification()"
    aria-label="Rouvrir la notification">
    <span class="pin-icon">
      <mat-icon>{{ getIcon() }}</mat-icon>
    </span>
    <span class="pin-content">
      <strong>{{ notification.message }}</strong>
      <small>
        <span *ngIf="detailCount() > 0">{{ getCountLabel() }} correction<ng-container *ngIf="detailCount() > 1">s</ng-container> en attente</span>
        <span *ngIf="detailCount() === 0">{{ notification.timestamp | date:'HH:mm:ss' }}</span>
      </small>
    </span>
    <span class="pin-open">
      <mat-icon>open_in_full</mat-icon>
    </span>
  </button>
</ng-container>
